import { Schema } from "@comparaonline/special-events-schema";
import React from "react";
import { Query } from "react-apollo";
import { promotionQuery } from "../promotion/PromotionQuery";
import { PromotionProvider } from "../../lib/promotionContext";

type PromotionArguments = Schema.SpecialEventsQueryArgs;
type PromotionQuery = Schema.Query;

class BaseQuery extends Query<PromotionQuery, PromotionArguments> {}

export interface PromotionQueryProps {
  variables: PromotionArguments;
}

export const PromotionQuery: React.FC<PromotionQueryProps> = ({ children, variables }) => {
  const { businessUnit } = variables;

  if (!businessUnit) {
    return <PromotionProvider value={null}>{children}</PromotionProvider>;
  }

  return (
    <BaseQuery query={promotionQuery} variables={variables}>
      {({ data, error }) => {
        if (error) {
          throw error;
        }
        const promotion = data && data.specialEvents ? data.specialEvents : null;
        return <PromotionProvider value={promotion}>{children}</PromotionProvider>;
      }}
    </BaseQuery>
  );
};
